module.exports = __webpack_public_path__ + "static/img/nuevos_07.ce52ceb5.jpg";